// extracted by mini-css-extract-plugin
export default {"rowPadding":"InfoCards_rowPadding__bahMd","behaviorPadding":"InfoCards_behaviorPadding__z1h5X"};